import * as yup from "yup"
import type { Story } from "../../types"

export function initialValuesStory(story?: Story | undefined) {
  if (story) {
    return story
  }
  return {
    title: "",
    subtitle: "",
    description: "",
    cover: "",
  }
}

export function validationSchemaStory() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    subtitle: yup.string().required("Campo obbligatorio"),
    cover: yup.string().required("Campo obbligatorio"),
  })
}
